export enum ChartType {
  LINE = "LINE",
  PIE = "PIE",
  DOUGHNUT = "DOUGHNUT",
  BAR = "BAR",
  TREND_LINE = "TREND LINE",
  MULTI_AXIS = "MULTI AXIS",
  STACKED_BAR = "STACKED BAR",
  STACKED_BAR_GROUP = "STACKED BAR GROUP",
  STACKED_BAR_LINE = "STACKED BAR LINE",
}
